<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Cash payment</ion-title>
  </ion-toolbar>

</ion-header>

<ion-content>
  @if (cart) {
    <ion-grid class="large-inputs" style="width: 400px;">
      <ion-row class="ion-align-items-center ion-justify-content-center">
        <ion-col>
          <ion-list>
            <ion-item lines="full">
              <ion-label>Amount due</ion-label>
              {{cart.currency.sign}}{{cart.amount_due | number:'1.2'}}
            </ion-item>
            @if (cash_rounding_difference) {
              <ion-item lines="full">
                <ion-label>Rounding</ion-label>
                @if (cash_rounding_direction == '-') {
                  –
                  }{{cart.currency.sign}}{{cash_rounding_difference | number:'1.2'}}
                </ion-item>
                <ion-item lines="full">
                  <ion-label>Rounded amount due</ion-label>
                  {{cart.currency.sign}}{{amount_due_rounded | number:'1.2'}}
                </ion-item>
              }
              <ion-item lines="full">
                <ion-input type="tel" class="ion-text-right" inputmode="decimal" maxlength="10" label="Amount tendered" [(ngModel)]="payment_amount" (ngModelChange)="sanitisePaymentAmount()" (keydown.enter)="enterPressed()"></ion-input>
              </ion-item>
              @if (change > 0) {
                <ion-item lines="none">
                  <ion-label>Change due</ion-label>
                  {{cart.currency.sign}}{{change | number:'1.2'}}
                </ion-item>
              }
              <ion-item lines="none" class="predefined-amounts ion-no-padding">
                <ion-grid>
                  <ion-row>
                    @for (n of [5,10,20,50,100]; track n) {
                      <ion-col><ion-button expand="block" (click)="addPredefinedAmount(n)">{{cart.currency.sign}}{{n}}</ion-button></ion-col>
                    }
                  </ion-row>
                </ion-grid>
              </ion-item>
              @if (payment.price > 0) {
                <ion-item button="true" lines="none" detail="false" color="success" class="ion-text-center" (click)="addPayment()">
                  <ion-label>ADD PAYMENT</ion-label>
                </ion-item>
              }
            </ion-list>
          </ion-col>
        </ion-row>
      </ion-grid>
    }
  </ion-content>
